import { render } from "./FooterText.vue?vue&type=template&id=72cfc1bd"
import script from "./FooterText.vue?vue&type=script&lang=js"
export * from "./FooterText.vue?vue&type=script&lang=js"

import "./FooterText.vue?vue&type=style&index=0&id=72cfc1bd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__